import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import { mapProps, compose, branch, renderNothing } from 'recompose'
import Body from 'components/typography/body2/index'
import { Button } from 'react-toolbox/lib/button'
import notifyHoc from 'containers/App/Notification/Notify'
import T from 'i18n-react'

import Divider from 'components/fulcrum/divider/Divider'
import UserSelection from './UserSelection'

import styles from './styles.scss'

const InfoButton = notifyHoc(Button)

const UserInput = ({onClick, ...rest}) => {
  return (
    <div>
      <Divider/>
      <div styleName='userInputHeader'>
        <Body>Add new user</Body>
      </div>
      <Flex
        align='center'
        auto
        justify='space-between'
        styleName='userInputContainer'
      >
        <div styleName='userInput'>
          <UserSelection {...rest}/>
        </div>
        <Flex
          justify='flex-end'
          styleName='addButton'
        >
          <InfoButton
            message={T.translate('pages.profile.notification.add')}
            floating
            icon='add'
            mini
            primary
            onClick={onClick}
          />
        </Flex>
      </Flex>
    </div>
  )
}

const withStyle = CSSModules(styles)

export default compose(
  mapProps(({addSubstitute, value, ...rest}) => ({
    onClick: () => addSubstitute(value),
    value,
    ...rest
  })),
  branch(
    ({ edit }) => !edit,
    renderNothing
  ),
  withStyle
)(UserInput)
